//import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
 
// import { FiUsers } from "react-icons/fi";
import { FaUserPlus, FaUsersRectangle } from "react-icons/fa6"; 
const Settings =()=>{
    return (
        <Wrapper pageTitle={'Settings'}>
            
            <div className="w-full overflow-hidden rounded-lg shadow-xs">
                <div className="w-full overflow-x-auto">
                    <ul className="flex flex-row space-x-4">
                        <li>
                        <Link className="flex items-center btn btn-sm btn-outline-secondary px-5" to="/users">
                            <FaUserPlus className="mr-2" />
                            <span>Register Users</span>
                        </Link>
                        </li>
                        <li>
                        <Link className="flex items-center btn btn-sm btn-outline-secondary px-5" to="/roles">
                            <FaUsersRectangle className="mr-2" />
                            <span>Roles</span>
                        </Link>
                        </li>
                    </ul>
                </div>
                   
            </div>
             
        </Wrapper>
         );
}

export default Settings;